/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/NewAddress/Content/CloseAction",
  isHovered
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 type="ghost"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<React.Fragment>
<TysiaIconClose
{...childProps}
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={childProps.isHovered ? dtColorsNeutral500 : dtColorsNeutral400}
/>
<Shortcut
{...childProps}
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 type="keyup"
 onPress={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
/>
</React.Fragment>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}